import { WSElement } from "@wingspanhq/fe-component-library";
import { ReactNode } from "react";
import styles from "./EmbeddedLayout.module.scss";

type Props = {
  children: ReactNode;
};

export const EmbeddedLayout: React.FC<Props> = props => (
  <WSElement className={styles.layout}>{props.children}</WSElement>
);
